import React, { Component } from 'react';
import { Container, Row, Col, Button } from 'reactstrap';
import { Link } from 'react-router'

import '../styles/confirmation.css';


class RegisterConfirmation extends Component {
    
   constructor(props) { 
        super(props);
        this.state={}
   }

   render() {

        return (
            <Container >
              <div className="page-register-confirmation">

                    <Row>
                        <Col>
                            <Link to="/"><div className="bloc-right center close">X</div></Link>
                        </Col>
                    </Row>

                    <div className="page-register-confirmation-container">
                        <Row>
                            <Col>
                                <div className="confirmation-title">Votre compte est maintenant créé, vous pouvez dès à présent compléter votre dossier.</div>
                                <div className="confirmation-subitle nodisplay">
                                    You probably haven't heard of them iceland biodiesel flexitarian. Crucifix letterpress 90's, banh mi humblebrag quinoa iPhone you probably haven't heard of them. Mixtape ennui cornhole tumeric.
                                </div>
                            </Col>
                        </Row>

                    </div>

                    <div  className="page-register-confirmation-container-action">
                      <Row>
                          <Col>
                              <Link to="/"><Button className="btn-transparent">Plus tard</Button></Link>
                              <Link to="/prestataire/fiche/inscription"><Button className="btn-green">Compléter maintenant</Button></Link>
                          </Col>
                      </Row>
                    </div>

                </div>
            </Container>
        )
    }
}

export default RegisterConfirmation


// WEBPACK FOOTER //
// ./src/user/components/RegisterConfirmation.js